import {fullAccessRolesOrganization} from "../Constants";

const useIsAccessGranted = (allowedRoles, customer) => {
    const profile = JSON.parse(localStorage.getItem("profile"))
    const profileRoles = profile?.userRoles.map(({name}) => name)
    const allRoles = customer ? allowedRoles : [...allowedRoles, ...fullAccessRolesOrganization]

    return allRoles.some((role) => profileRoles?.includes(role))
}
export {useIsAccessGranted}